import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import Message from '@jetbrains/ring-ui/components/message/message';
import classNames from 'classnames';
import { H2 } from '@jetbrains/ring-ui/components/heading/heading';
import closeIcon from '@jetbrains/icons/close';
import Button from '@jetbrains/ring-ui/components/button/button';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useSynchronizedTooltipState } from './synchronized-popup-state';
import styles from './popup-message.css';
function PopupMessageWithRef(props, ref) {
    const { children, anchor, title, directions, className, icon, delay = 500 } = props;
    const [messageVisible, setMessageVisible] = useSynchronizedTooltipState();
    const timeoutRef = useRef();
    const onMouseEnter = useCallback(() => {
        timeoutRef.current = window.setTimeout(() => {
            setMessageVisible(true);
        }, delay);
    }, [setMessageVisible, delay]);
    const onMouseLeave = useCallback(() => window.clearTimeout(timeoutRef.current), []);
    useImperativeHandle(ref, () => ({
        show: () => setMessageVisible(true),
        hide: () => setMessageVisible(false)
    }), [setMessageVisible]);
    return (_jsxs("div", { className: classNames(styles.wrapper, className), ...assignTestId('popup-message-wrapper'), children: [children && messageVisible && (_jsxs(Message, { icon: icon !== null && icon !== void 0 ? icon : null, className: classNames(styles.popup, { [styles.messageIcon]: !!icon }), popupProps: { onOutsideClick: () => setMessageVisible(false) }, directions: directions, children: [_jsx(Button, { icon: closeIcon, className: styles.closeButton, onClick: () => setMessageVisible(false), ...assignTestId('popup-message-close-button') }), _jsxs("div", { className: classNames({ [styles.withIcon]: !!icon }), children: [title && (_jsx(H2, { className: styles.title, ...assignTestId('popup-message-title'), children: title })), _jsx("div", { className: styles.content, children: children })] })] })), _jsx("div", { className: styles.anchorWrapper, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: anchor })] }));
}
export const PopupMessage = forwardRef(PopupMessageWithRef);
